export const APP_INITIALIZE = 'APP_INITIALIZE';
export const APP_SET_IS_INITIALIZING = 'APP_SET_IS_INITIALIZING';
export const APP_INITIALIZE_FAILURE = 'APP_INITIALIZE_FAILURE';
export const APP_SET_SERVICE_WORKER_UPDATE_AVAILABLE = 'APP_SET_SERVICE_WORKER_UPDATE_AVAILABLE';
export const APP_ENQUEUE_TASK = 'APP_ENQUEUE_TASK';
export const APP_UPDATE_QUEUED_TASK = 'APP_UPDATE_QUEUED_TASK';
